import {
  createContext,
  FunctionComponent,
  ReactNode,
  useContext,
  useState,
} from "react";
import { Nil } from "cy-util";
import { useRouteState } from "../../hooks";
import { cn } from "../../utils/cn";

export type StatusFilterOptions = {
  useRouteStore?: boolean;
  name?: string;
  defaultValue?: string;
};

export function useStatusFilter(opts: StatusFilterOptions = {}) {
  const { defaultValue, name } = opts;
  const key = name || "status";

  const reactState = useState<string | undefined>(defaultValue);
  const routerState = useRouteState().useState(key, defaultValue);

  const [selectedId, setSelectedId] = opts.useRouteStore
    ? routerState
    : reactState;

  function onToggle(id: string) {
    setSelectedId((x: string | undefined) => (x === id ? undefined : id));
  }

  return { selectedId, onToggle };
}

export interface StatusFilterProps {
  className?: string;
  children: ReactNode;
  selectedId: string | Nil;
  onToggle: (id: string) => void;
}

export interface StatusFilterContextValue {
  toggle: (id: string) => void;
  selectedId: string | Nil;
}

const StatusFilterContext = createContext<StatusFilterContextValue | null>(
  null,
);

export function useStatusFilterContext() {
  const ctx = useContext(StatusFilterContext);
  if (ctx == null) {
    throw new Error("You must use StatusFilterButton in a Status Filter");
  }
  return ctx;
}

/**
 *
 */
export const StatusFilter: FunctionComponent<StatusFilterProps> = ({
  className,
  children,
  selectedId,
  onToggle,
}) => {
  function toggle(id: string) {
    onToggle && onToggle(id);
  }

  // const childrenWithProps = React.Children.map(children, (child, index) => {
  //   // TODO: Change this to use react context.
  //   if (React.isValidElement(child)) {
  //     return React.cloneElement(child, {
  //       selected: value === child.props.id,
  //       onClick: (value: string) => click(value, index),
  //     });
  //   }
  //   return child;
  // });
  const css = cn(
    className,
    "flex gap-3 sm:gap-4 flex-wrap bg-white px-2 py-3 sm:px-3 rounded-lg border shadow min-h-[5.8rem]",
  );
  // if (!childrenWithProps?.length) {
  //   return null;
  // }
  return (
    <StatusFilterContext.Provider value={{ toggle, selectedId }}>
      <div className={css}>{children}</div>
    </StatusFilterContext.Provider>
  );
};
